<script>
import { deleteManager, getManagers } from '@/api/organizations/organizations';
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import BaseTable from '@/components/ui/Table/Table.vue';
import AddButton from '@/views/organizations/components/AddButton.vue';
import BaseHeader from '@/views/organizations/components/BaseHeader.vue';
import DeleteButton from '@/views/organizations/components/DeleteButton.vue';
import EditButton from '@/views/organizations/components/EditButton.vue';
import BaseTag from '@/views/organizations/managers/components/BaseTag.vue';
import StatusTag from '@/views/organizations/managers/components/StatusTag.vue';

export default {
  name: 'Index',
  components: { BaseHeader, AddButton, Breadcrumbs, DeleteButton, EditButton, BaseTag, StatusTag, BaseTable },
  data() {
    return {
      managers: [],
      total: 0,
      headers: {
        fullName: 'Імʼя',
        status: 'Статус',
        role: 'Роль',
        commands: 'Команди',
        actions: ' ',
      },
      page: 1,
      perPage: 15,
      lastPage: 1,
    };
  },
  methods: {
    getManagers() {
      const params = this.$route.params;
      const keys = Object.keys(params);
      const lastParamKey = keys[keys.length - 1];
      const lastParamValue = params[lastParamKey] ?? this.$store.getters.USER.organizationId;

      getManagers(lastParamValue).then(response => {
        this.managers = response.data.data;
        this.page = response.data.meta.current_page;
        this.perPage = response.data.meta.per_page;
        this.lastPage = response.data.meta.last_page;
        this.total = response.data.meta.total;
      });
    },
    edit(id) {
      this.$router.push({ name: this.$route.name + '.edit', params: { ...this.$route.params, managerId: id } });
    },
    deleteManager(id) {
      this.$confirm('Ви дійсно бажаєте видалити менеджера?', {
        confirmButtonText: 'Так',
        cancelButtonText: 'Ні',
        type: 'warning'
      }).then(() => {
        deleteManager(id).then(() => {
          this.getManagers();

          this.$message({
            type: 'success',
            message: 'Менеджера видалено',
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Видалення скасовано'
        });
      });
    },
  },
  created() {
    this.getManagers();
  }
};
</script>

<template>
    <div class="managers">
        <BaseHeader/>
<!--        multiselect-->

        <BaseTable
            :headers="headers"
            :data="managers"
            :page="page"
            :total="lastPage"
        >
            <template #header-content>
                <div>
                    Менеджери
                </div>
                <BaseTag>{{ total }} менеджерів</BaseTag>
            </template>
            <template #name="{ value }">
                <div class="name">
                    {{ value }}
                </div>
            </template>
            <template #status="{ value }">
                <status-tag>Активний</status-tag>
            </template>
            <template #commands="{ value }">
                <div class="d-flex" v-for="item in value" :key="item">
                    <BaseTag>{{ item }}</BaseTag>
                </div>
            </template>
            <template #actions="{row}">
                <div class="d-flex gap-3">
                    <edit-button @click="edit(row.id)"/>
                    <delete-button @click="deleteManager(row.id)"/>
                </div>
            </template>
        </BaseTable>
    </div>
</template>

<style scoped lang="scss">
.managers {
    .name {
        /* Text sm / Medium */
        font-family: Inter, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */

        /* Gray/900 */
        color: #181D27;


        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
    }

    ::v-deep .table-content {
        min-width: 800px;
    }
}

.gap-3 {
    gap: 12px;
}
</style>

